import {OotherSCCCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const OotherSCCCRequestInit = () => {
    return {
        type: OotherSCCCActionType.OotherSCCC_INIT
    }
}

export const OotherSCCCSuccess = (
    objeckt: any
) => {
    return {
        type: OotherSCCCActionType.OotherSCCC_INIT,
        objeckt: objeckt
    }
}

export const getOotherSCCC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            OotherSCCCSuccess(
                objeckt
            )
        )
    }
}
